import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { StateService } from '../../services/state.service';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'lib-signature',
    templateUrl: './signature.component.html',
    styleUrls: ['./signature.component.scss'],
    standalone: false
})
export class SignatureComponent {
  @Output()
  saveSignature: EventEmitter<string> = new EventEmitter<string>();
  @Input()
  currentSignature: string;
  @ViewChild('canvas', { static: true })
  canvasRef!: ElementRef<HTMLCanvasElement>;
  private ctx!: CanvasRenderingContext2D;
  private drawing = false;
  base64Image: string = '';
  sub: Subscription;
  private emptyCanvasDataUrl: string = '';

  ngAfterViewInit() {
    const canvas = this.canvasRef.nativeElement;
    this.ctx = canvas.getContext('2d')!;
    this.ctx.lineWidth = 3; // etwas dicker
    this.ctx.lineCap = 'round'; // Rundes Ende
    this.ctx.lineJoin = 'round'; // Weiche Übergänge
    this.ctx.strokeStyle = '#000'; // Dunkelgraue Farbe
    this.emptyCanvasDataUrl =
      this.canvasRef.nativeElement.toDataURL('image/png');
    if (this.currentSignature) this.loadBase64Image(this.currentSignature);
  }

  loadBase64Image(base64: string) {
    const img = new Image();
    img.onload = () => {
      this.ctx.drawImage(
        img,
        0,
        0,
        this.canvasRef.nativeElement.width,
        this.canvasRef.nativeElement.height
      );
    };
    img.src = base64;
  }

  private getEventCoordinates(event: MouseEvent | TouchEvent): {
    x: number;
    y: number;
  } {
    const canvas = this.canvasRef.nativeElement;
    const rect = canvas.getBoundingClientRect();

    if (event instanceof TouchEvent) {
      const touch = event.touches[0];
      return {
        x: touch.clientX - rect.left,
        y: touch.clientY - rect.top,
      };
    } else {
      return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
      };
    }
  }

  startDrawing(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    this.drawing = true;
    const { x, y } = this.getEventCoordinates(event);
    this.ctx.beginPath();
    this.ctx.moveTo(x, y);
  }

  draw(event: MouseEvent | TouchEvent) {
    if (!this.drawing) return;
    event.preventDefault();
    const { x, y } = this.getEventCoordinates(event);
    this.ctx.lineTo(x, y);
    this.ctx.stroke();
  }

  stopDrawing() {
    this.drawing = false;
  }

  saveAsBase64() {
    const canvas = this.canvasRef.nativeElement;
    this.base64Image = canvas.toDataURL('image/png');
    if (this.base64Image === this.emptyCanvasDataUrl) this.base64Image = '';
    this.saveSignature.emit(this.base64Image);
  }

  clearCanvas() {
    const canvas = this.canvasRef.nativeElement;
    this.ctx.clearRect(0, 0, canvas.width, canvas.height);
    this.base64Image = '';
  }
}
